import React from 'react';
import { useResponsive } from '@sg/garnish';

import { AccountScreenContainer, AccountScreenTitle } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import {
  SkeletonLoadingContentLG,
  SkeletonLoadingContentSM,
  SkeletonLoadingHeaderXS,
} from './AccountSkeletonLoading';

export const AccountPaymentCreditLoading = () => {
  const { t } = useLocalizationContext();
  const { currentBreakpoint } = useResponsive();

  return (
    <AccountScreenContainer screen="payment-credit">
      <AccountScreenTitle
        visibility="COMPACT"
        title={t('account.payment-promo.title')}
      />

      {/* Payment Methods */}
      <SkeletonLoadingHeaderXS />
      <SkeletonLoadingContentSM />
      <SkeletonLoadingContentSM />

      {currentBreakpoint.isXS ? (
        <>
          {/* Credit and Promo Code Links */}
          <SkeletonLoadingHeaderXS />
          <SkeletonLoadingContentSM />
          <SkeletonLoadingContentSM />
        </>
      ) : (
        <>
          {/* Credit and Promo Code Form */}
          <SkeletonLoadingHeaderXS />
          <SkeletonLoadingContentLG />
          <SkeletonLoadingContentSM />
          <SkeletonLoadingContentLG />
        </>
      )}
    </AccountScreenContainer>
  );
};
